export function HorizontalRule() {
	return <hr class="border-neutral-500" />;
}
